import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    BIPETROSUPPLY: 'BI PetroSupply'
}

export default [
    {
        name: ROUTER_NAMES.BIPETROSUPPLY,
        path: '/bi-petrosupply',
        meta: {
            menu: MENUS.FUNCIONALIDAES,
            title: 'BI PetroSupply',
            searchAlias: 'BI PetroSupply',
            searchDescription: 'Painel Power BI do PetroSupply',
            searchTerms: ['BI PetroSupply', 'Power BI', 'BI'],
            hasRole: 'role/bi-petrosupply'
        },
        component: () => import('@/views/BiPetroSupply')
    },
]
